<script setup lang="ts">
// Ports v3 `Skeletons/DashboardSkeleton.vue` (78 ln), which hand-rolled its shimmer with Tailwind
// `animate-pulse` divs. Module 02's `Skeleton` owns the animation and the reduced-motion opt-out,
// so this is only the widget-shaped arrangement of it: a title bar over a content block.
//
// The report kinds never mount this — 08's `DataVisible` owns their loading state (§14, and the
// reason 09 must not re-implement report chrome). It is the loading state for the two widgets that
// read 08's data layer directly, and for a lazily-loaded registry embed.
import { Skeleton } from '@/shared/ui'

// `label` is optional because Vue mounts this as `defineAsyncComponent`'s `loadingComponent`,
// which passes no props. `role="status"` + `aria-live` still announce the pending region; the
// label only names it when a caller has one, and a hardcoded English default would be a raw
// user-facing string (BRIEF §4.8).
withDefaults(defineProps<{ rows?: number; label?: string }>(), { rows: 3 })
</script>

<template>
  <div
    class="dashboard-widget-skeleton flex flex-col gap-xs p-sm"
    role="status"
    :aria-label="label"
    aria-live="polite"
  >
    <Skeleton width="40%" height="1rem" />
    <Skeleton v-for="row in rows" :key="row" height="2.25rem" />
  </div>
</template>
